module.exports = __webpack_public_path__ + "20272da55ec630101922be573ff501f0.png";